import { useMediaQuery } from 'react-responsive';

const useIsMaxScreen = () => {
  const isMobile = useMediaQuery({ minWidth: 1441 });
  return isMobile;
};

export default useIsMaxScreen;
